module.exports = __webpack_public_path__ + "static/img/16.dbae7b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about/16.jpg
// module id = i6dG
// module chunks = 1